import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import NavbarModal from "../modal/NavbarModal";

// $$ images $$ \\
import tel from "../../assets/images/tel.svg";
import clock from "../../assets/images/clock.svg";
import location from "../../assets/images/location.svg";

// $$ styles $$ \\
import "../../assets/styles/header.scss";

// $$ Icons $$ \\
import { GiHamburgerMenu } from "react-icons/gi";

const Header = () => {
  const navbarMobile = document.querySelector(".navbarMobile");
  const [active, setActive] = useState(false);

  const navModal = () => {
    console.log("hello");
    return setActive(!active);
  };

  return (
    <div className="header">
      <div className="container">
        <div className="header_items">
          <div className="header_items_logo">
            <Link to={"/"} className="header_items_logo_link">
              med<span>dical</span>
            </Link>
          </div>

          <div className="header_items_contacts">
            <div className="tel">
              <div className="tel_img">
                <img src={tel} alt="tel" />
              </div>
              <div className="content">
                <p className="text">Emergency</p>
                <p className="num">(237) 681-812-255</p>
              </div>
            </div>

            <div className="tel">
              <div className="tel_img">
                <img src={clock} alt="tel" />
              </div>
              <div className="content">
                <p className="text">Work Hour</p>
                <p className="num">09:00 - 20:00 Everyday</p>
              </div>
            </div>

            <div className="tel">
              <div className="tel_img">
                <img src={location} alt="tel" />
              </div>
              <div className="content">
                <p className="text">Location</p>
                <p className="num">0123 Some Place</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="navbar">
        <div className="container">
          <ul>
            <li>
              <NavLink to={"/"} className="navbar_Link">
                Home
              </NavLink>
            </li>
            <li>
              <NavLink to={"/aboutUs"} className="navbar_Link">
                About us
              </NavLink>
            </li>
            <li>
              <NavLink to={"/services"} className="navbar_Link">
                Services
              </NavLink>
            </li>
            <li>
              <NavLink to={"/doctors"} className="navbar_Link">
                Doctors
              </NavLink>
            </li>
            <li>
              <NavLink to={"/contact"} className="navbar_Link">
                Contact
              </NavLink>
            </li>
            <li>
              <NavLink to={"/news"} className="navbar_Link">
                News
              </NavLink>
            </li>
          </ul>

          <div className="search_box">
            <select name="lang" id="lang">
              <option value="Uzbek">Uzbek</option>
              <option value="Rus">Rus</option>
              <option value="Eng">Eng</option>
            </select>

            <div className="appointment">
              <Link to={"/appointment"} className="appointment_Link">
                Appointment
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className={`navbarMobile `}>
        <div className="container">
          <div className="navbar_items">
            <div className="logo">
              <Link to={"/"} className="header_items_logo_link">
                med<span>dical</span>
              </Link>
            </div>

            <div className="burger_icons">
              <GiHamburgerMenu onClick={navModal} className="burger" />
            </div>
          </div>
        </div>
      </div>

      <NavbarModal navModal={navModal} active={active} setActive={setActive} />
    </div>
  );
};

export default Header;
